/**
 * React hook to apply Korean address and phone number replacement to any content
 * This is a temporary fix to replace:
 * - Old Korean address with the new one
 * - Old Italian phone number with the new one
 */

import { useMemo } from 'react';
import { replaceKoreanAddressInObject } from './replaceKoreanAddress';

/**
 * Hook to apply Korean address and phone number replacement to any data structure
 * @param data - The data to process
 * @returns The data with Korean address and phone number replaced
 */
export const useKoreanAddressFix = <T>(data: T): T => {
  return useMemo(() => {
    return replaceKoreanAddressInObject(data);
  }, [data]);
};